/* tslint:disable */
export const de_overrides_strings = {
};
